import React from 'react';

import {AnalysisGraphQL, GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {getDataFrameFilterOptionsForView} from 'analysis-tool/filters/GetDataFrameFilterOptions';
import FilterPillList, {AdditionalFilters} from 'data-frames/filters/components/FilterPillList';

const PARENT_FILTER_MESSAGE = 'This filter has been inherited from the analysis table.';

interface FilterPillListForVisualizationProps {
  analysis: AnalysisGraphQL;
  viewSteps: Array<GetAnalysisPipelineStep>;
}

export default function FilterPillListForVisualization({
  analysis,
  viewSteps,
}: FilterPillListForVisualizationProps): JSX.Element {
  const {filterOptions, readOnlyInfo} = getDataFrameFilterOptionsForView(analysis, viewSteps);

  const parentFilterOptionsList: Array<AdditionalFilters> = filterOptions
    ?.getFiltersWithMetadata({includeTopLevelFilterSteps: true, includeViewFilterSteps: false})
    .map((filterWithMetadata) => ({
      disabled: true,
      tooltipTitle: PARENT_FILTER_MESSAGE,
      filterWithMetadata,
    }));

  const viewFilterOptionsList: Array<AdditionalFilters> = filterOptions
    ?.getFiltersWithMetadata({})
    .map((filterWithMetadata) => ({
      disabled: false,
      filterWithMetadata,
    }));

  return (
    <FilterPillList
      filterOptions={filterOptions}
      readOnlyInfo={readOnlyInfo}
      additionalFilters={parentFilterOptionsList.concat(viewFilterOptionsList)}
    />
  );
}
